import {  Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  success(summary: string, detail?: string, life = 3000) {
    this.toast('success', summary, detail, life);
  }

  info(summary: string, detail?: string, life = 3000) {
    this.toast('info', summary, detail, life);
  }

  warn(summary: string, detail?: string, life = 3000) {
    this.toast('warn', summary, detail, life);
  }

  error(summary: string, detail?: string, life = 3000) {
    this.toast('error', summary, detail, life);
  }

  private toast(severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail?: string, life = 3000) {
    const msg: ToastMessageOptions = {
      
      severity,
      summary,
      detail: detail ?? '',
      life,
      key: 'global'
    };
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }
}
